import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { ArrowLeft, AlertTriangle, Lightbulb, TrendingUp } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Block = ({ icon: Icon, title, text, color }) => (
  <div className="bg-white p-6 border-l-4 shadow-sm" style={{ borderColor: color }}>
    <div className="flex items-center gap-3 mb-3">
      <Icon size={22} style={{ color }} />
      <h3 className="font-display font-bold text-foreground">{title}</h3>
    </div>
    <p className="text-gray-600 leading-relaxed">{text}</p>
  </div>
);

const CaseStudyDetail = () => {
  const { id } = useParams();
  const [cs, setCs] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/case-studies/${id}`)
      .then((res) => setCs(res.data))
      .catch(() => setCs(null))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-[150px] pb-20 bg-gray-50" data-testid="casestudy-detail">
        <div className="container mx-auto px-4 max-w-4xl">
          <Link to="/case-studies" className="inline-flex items-center gap-2 text-primary text-sm font-bold uppercase tracking-wider mb-8 hover:underline">
            <ArrowLeft size={16} /> Back to Case Studies
          </Link>

          {loading ? (
            <p className="text-gray-500">Loading…</p>
          ) : !cs ? (
            <p className="text-gray-500">Case study not found.</p>
          ) : (
            <div className="space-y-8">
              <div>
                <span className="text-xs uppercase tracking-widest text-gold font-bold">{cs.industry}</span>
                <h1 className="text-4xl font-display font-bold text-foreground mt-2 mb-2 leading-tight">{cs.title}</h1>
                <p className="text-gray-500">Client: {cs.client}</p>
              </div>
              {cs.image && <img src={cs.image} alt={cs.title} className="w-full h-[360px] object-cover shadow-lg" />}
              <p className="text-lg text-gray-700 leading-relaxed">{cs.summary}</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <Block icon={AlertTriangle} title="Challenge" text={cs.challenge} color="#b45309" />
                <Block icon={Lightbulb} title="Solution" text={cs.solution} color="#001F3F" />
                <Block icon={TrendingUp} title="Results" text={cs.results} color="#15803d" />
              </div>
              <div className="bg-primary text-white p-8 text-center">
                <h3 className="text-2xl font-display font-bold mb-3">Have a similar challenge?</h3>
                <Link to="/contact" className="inline-block bg-gold text-slate-900 font-bold uppercase tracking-widest px-8 py-3 hover:bg-gold/90 transition-colors">Partner With Us</Link>
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CaseStudyDetail;
